<template>
  <v-dialog v-model="dialog" width="609" persistent>
    <v-card class="custom-card" rounded="0">
      <v-toolbar color="secondary" class="white--text">
        <v-toolbar-title v-if="animalLaboratory.id" class="font-weight-bold">{{
          $t("animal.healthRecordInfo.editLabratoryResults")
        }}</v-toolbar-title>
        <v-toolbar-title v-else class="font-weight-bold">{{
          $t("animal.healthRecordInfo.addLabratoryResults")
        }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon class="white--text" @click="closeModal">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-form
        autocomplete="off"
        ref="form"
        v-model="valid"
        @submit.prevent="addNote"
      >
          
        <v-card-text class="black--text">

        <label class="label">
              {{ $t("animal.healthRecordInfo.dateUploaded") }}
              <v-tooltip top color="black" max-width="350">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon v-bind="attrs" v-on="on">
                    mdi-help-circle-outline
                  </v-icon>
                </template>
                <span>{{ $t("animal.healthRecordInfo.dateUploadedTooltip") }}</span>
              </v-tooltip>
            </label>
            <v-menu
              v-model="dateUploadedMenu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="animalLaboratory.dateUploaded"
                  append-icon="mdi-calendar"
                  outlined
                  dense
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  v-on:click:append="dateUploadedMenu = true"
                  placeholder="Select date"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="animalLaboratory.dateUploaded"
                @input="dateUploadedMenu = false"
              ></v-date-picker>
            </v-menu>


          <label class="title" for="name">{{
            $t("animal.healthRecordInfo.labratoryName")
          }}
        <v-tooltip top color="black" max-width="350">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon v-bind="attrs" v-on="on">
                    mdi-help-circle-outline
                  </v-icon>
                </template>
                <span>{{ $t("animal.healthRecordInfo.labratoryNameTooltip") }}</span>
              </v-tooltip>  
        </label>
          <v-text-field
            v-model="animalLaboratory.laboratoryName"
            placeholder="Enter Name"
            outlined
            class="mt-3"
          ></v-text-field>

          <label class="title" for="name">{{
            $t("animal.healthRecordInfo.labratoryAttended")
          }}
          
          <v-tooltip top color="black" max-width="350">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon v-bind="attrs" v-on="on">
                    mdi-help-circle-outline
                  </v-icon>
                </template>
                <span>{{ $t("animal.healthRecordInfo.labratoryAttendedTooltip") }}</span>
              </v-tooltip></label>
          <v-text-field
            v-model="animalLaboratory.laboratoryAttended"
            placeholder="Enter Name"
            outlined
            class="mt-3"
          ></v-text-field>

          <label class="title" for="name">{{
            $t("animal.healthRecordInfo.notes")
          }}
          
          <v-tooltip top color="black" max-width="350">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon v-bind="attrs" v-on="on">
                    mdi-help-circle-outline
                  </v-icon>
                </template>
                <span>{{ $t("animal.healthRecordInfo.notesTooltip") }}</span>
              </v-tooltip></label>
          <v-text-field
            v-model="animalLaboratory.notes"
            placeholder="Notes"
            outlined
            class="mt-3"
          ></v-text-field>

          <label class="title" for="name">{{
            $t("animal.healthRecordInfo.updateReports")
          }}
          
          <v-tooltip top color="black" max-width="350">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon v-bind="attrs" v-on="on">
                    mdi-help-circle-outline
                  </v-icon>
                </template>
                <span>{{ $t("animal.healthRecordInfo.updateReportsTooltip") }}</span>
              </v-tooltip></label>
          <v-file-input
            v-model="selectedFile"
            outlined
            placeholder="Click to Upload"
            single
            accept="application/pdf"
            :rules="pdfRules"
          >
            <template v-slot:selection="{ text }">
              <v-chip small label color="primary">
                {{ text }}
              </v-chip>
            </template>
          </v-file-input>

          <v-card-actions class="">
            <v-spacer></v-spacer>
            <v-btn
              class=""
              outlined
              color="primary"
              @click="closeModal"
              width="112"
            >
              {{ $t("cancel") }}
            </v-btn>
            <v-btn
              type="submit"
              width="112"
              color="primary"
              class="btn-11 btn-22"
            >
              {{ $t("submit") }}
            </v-btn>
          </v-card-actions>
        </v-card-text>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import loading from "@/mixins/LoadingMixin";
import S3UploadServce from "@/_services/S3UploadService"
import gql from 'graphql-tag';
import moment from "moment";

export default {
  computed: {
    dialog() {
      return this.dialogI;
    },
    getTodayDate() {
      return moment().format("YYYY-MM-DD");
    },
  },
  data() {
    return {
      rules: {
        required: (value) => !!value || "Required.",
        min: (v) => v.length >= 8 || "Min 8 characters",
        emailMatch: () => `The email and password you entered don't match`,
        number: (v) => !isNaN(v) || "Not number",
      },
      pdfRules: [
                value => !value || value.size < 10485760 || 'Report size should be less than 10 mb'
            ],
      dateUploadedMenu:false,
      valid: true,
      selectedFile: null,
      animalLaboratory: {
        id: null,
        animalId: parseInt(this.$route.params.animal_number), 
        dateUploaded: "",
        laboratoryName: "",
        laboratoryAttended: "",
        notes: "",
        file: null,
      },
      laboratoryNameRules: [
        (v) => !!v || "Laboratory Name is Required",
        (v) =>
          (v && v.length <= 50) ||
          "Laboratory Name must be less than 50 characters",
      ],
      laboratoryAttendedRules: [
        (v) => !!v || "Laboratory Attendent is Required",
        (v) =>
          (v && v.length <= 50) ||
          "Laboratory Attendent must be less than 50 characters",
      ],
    };
  },
  methods: {
    
    closeModal() {
      this.$emit("closeAddDept");
    },
    async parseFile(file){
      return new Promise((resolve, reject) => {
        var fr = new FileReader();
        fr.readAsText(file);
        fr.onload = () => {
          resolve(fr.result )
        };
        fr.onerror = reject;
      });
    },
    async addNote() {
      if (!this.$refs.form.validate()) return;

      console.log(this.animalLaboratory.laboratoryName,this.animalLaboratory.dateUploaded,this.animalLaboratory.notes ,this.animalLaboratory.laboratoryAttended,this.animalLaboratory.file,"yy")

      if((this.animalLaboratory.laboratoryName == "" || this.animalLaboratory.laboratoryName == null) && 
            (this.animalLaboratory.dateUploaded == "" || this.animalLaboratory.dateUploaded == null) && 
            (this.animalLaboratory.notes == "" || this.animalLaboratory.notes == null) && 
            (this.animalLaboratory.laboratoryAttended == "" || this.animalLaboratory.laboratoryAttended == null) && 
            (this.animalLaboratory.file == "" || this.animalLaboratory.file == null)
            
            ) {
                this.$notify({
                        //title: `No details entered.`,
                        text: 'No details entered.',
                        type: "error",
                        position: "top right",
                    });
                return;
            }


      this.startLoading();
      if (!this.selectedFile) {this.animalLaboratory.file = "No File Chosen"}
      else{
        console.log(this.selectedFile,"this.selectedFile")
        let uploadedImage = await S3UploadServce.singleUpload(this.selectedFile,'registration');
        this.animalLaboratory.file = uploadedImage.fullPath;
      }
      
      const animalLaboratory={
            id: this.animalLaboratory.id,
            animalId: parseInt(this.$route.params.animal_number),
            laboratary_name: this.animalLaboratory.laboratoryName,
            date_uploaded: this.dateUploaded == ""?null:this.animalLaboratory.dateUploaded,
            notes: this.animalLaboratory.notes,
            
            laboratary_attended: this.animalLaboratory.laboratoryAttended,
            report_url: this.animalLaboratory.file, // todo
      }
      
      let mutation="";
      if(!animalLaboratory.id){
        delete animalLaboratory.id;
        mutation=`mutation createLabResults($data: CreateLabResults!) {
          createLabResults(createLabResultsInput: $data) {
            id
          }
        }`;
      }
      else{
        mutation=`mutation updateLabResults($data: UpdateLabResults!) {
          updateLabResults(updateLabResultsInput: $data) {
            id
          }
        }`;
      }
      
      this.$apollo.mutate({
        mutation: gql`${mutation}`,
        variables: {
          data: animalLaboratory
        }
      })
      .then(response => {
        if (response.data.createLabResults) {
          
          this.$notify({
            title: `Lab result added successfully`,
            text: response.message,
            type: "success",
            position: "top right",
          });
 
          this.$emit('labResult:added');
        }
        else{
          if (response.data.updateLabResults) {
          
          this.$notify({
            title: `Lab result updated successfully`,
            text: response.message,
            type: "success",
            position: "top right",
          });
 
          this.$emit('labResult:added');
        }
        }
      })
      .catch(e => {
        console.log(e);
        this.$notify({
          title: `Lab result cannot be added.`,
          text: e.message,
          type: "error",
          position: "top right",
        });
      })
      .finally(() => {
        this.stopLoading();
      });
    },
  },
  mounted(){
    if(this.laboratoryItem){
      
      
      let dateUploaded = null;
      if (this.laboratoryItem.dateUploaded) {
        dateUploaded = new Date(this.laboratoryItem.dateUploaded);
        dateUploaded =
          dateUploaded.getFullYear() +
          "-" +
          dateUploaded.getMonth() +
          "-" +
          dateUploaded.getDate();

      }
      
       this.animalLaboratory.id= this.laboratoryItem.id;
        this.animalLaboratory.dateUploaded= dateUploaded;
        this.animalLaboratory.laboratoryName= this.laboratoryItem.laboratoryName;
        this.animalLaboratory.laboratoryAttended= this.laboratoryItem.laboratoryAttended;
        this.animalLaboratory.notes= this.laboratoryItem.notes;
        this.animalLaboratory.file= this.laboratoryItem.file;
    }
  },
  props: ["dialogI","laboratoryItem"],
  mixins: [loading],
};
</script>
<style lang="scss" scoped>
.v-application .title {
  font-size: 16px !important;
  line-height: 0px !important;
  font-weight: normal;
}
</style>